// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import { Switch } from "@headlessui/react";

/* ------------------------------------- TOGGLE SWITCH ------------------------------------- */

const ToggleSwitch = ({
  enabled,
  setEnabled,
  showText = true,
  size = false,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
}: {
  enabled: boolean;
  setEnabled: any;
  showText?: boolean;
  size?: boolean;
  "data-testid"?: string;
  "aria-label"?: string;
}) => {
  return (
    <div
      onClick={() => {
        setEnabled(!enabled);
      }}
      className="relative cursor-pointer"
    >
      <Switch
        checked={enabled}
        onChange={(e) => setEnabled(e)}
        data-testid={dataTestId}
        aria-label={ariaLabel}
        className={`${enabled ? "bg-btnPrimaryActive" : "bg-btnSmall"}
          relative   flex items-center shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-white ${
            size ? "w-[35px] h-[20px]" : "w-[54px] h-6"
          }`}
      >
        <span
          aria-hidden="true"
          style={{
            boxShadow: enabled
              ? "0px 1px 3px 0px #2365B7"
              : "0px 1px 3px 0px #BCC1D2",
          }}
          className={`${enabled ? (!showText ? "translate-x-[16px]" : "translate-x-[30px]") : "translate-x-[1.5px]"}
            pointer-events-none inline-block  transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${
              size ? "h-[14px] w-[14px]" : "h-[18px] w-[18px]"
            }`}
        />
      </Switch>
      {enabled && showText ? (
        <div className="text-[11px] text-white font-bold absolute top-[4px] left-[9px] leading-normal">
          ON
        </div>
      ) : (
        ""
      )}
      {!enabled && showText ? (
        <div className="text-[11px] text-txtSecondary font-bold absolute top-[4px] right-[8px] leading-normal">
          OFF
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ToggleSwitch;
